<template>
  <!-- 开始修改：添加消息点击跳转功能 -->
  <div
    class="notification"
    :class="notification.type"
    @click="handleNotificationClick"
  >
    <!-- 结束修改：添加消息点击跳转功能 -->
    <div class="notification-header">
      <h3>{{ notification.title }}</h3>
      <!-- 右上角关闭按钮 -->
      <button class="close-btn" @click.stop="handleClose">
        <i class="fa fa-times">x</i>
      </button>
    </div>
    <div class="notification-body">
      <p>{{ notification.message }}</p>
    </div>
    <div class="notification-footer">
      <span>{{ formatTime(notification.timestamp) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: {
    notification: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    // 处理关闭按钮点击
    handleClose() {
      this.$emit("close");
    },

    // 开始修改：添加消息点击跳转方法
    /**
     * 处理消息主体点击事件，实现跳转功能
     */
    handleNotificationClick() {
      // 直接触发click事件，传递通知对象
      this.$emit("notification-click");
    },
    // 结束修改：添加消息点击跳转方法

    /**
     * 格式化时间显示
     */
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
  },
};
</script>

<style scoped>
.notification {
  width: 320px;
  border-radius: 6px;
  padding: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out forwards;
  background-color: white;
  transition: all 0.3s ease;
  cursor: pointer; /* 开始修改：添加指针样式表示可点击 */
  border: 1px solid #eee; /* 增强边框可见性 */
}
/* 结束修改：添加指针样式表示可点击 */

/* 不同类型通知的左侧标识 */
.notification.info {
  border-left: 4px solid #1890ff;
}

.notification.success {
  border-left: 4px solid #52c41a;
}

.notification.warning {
  border-left: 4px solid #faad14;
}

.notification.error {
  border-left: 4px solid #ff4d4f;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.notification-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #888;
  transition: color 0.2s;
  padding: 0 5px;
  /* 开始修改：确保关闭按钮层级高于内容 */
  position: relative;
  z-index: 10;
  /* 结束修改：确保关闭按钮层级高于内容 */
}

.close-btn:hover {
  color: #ff4d4f;
  transform: scale(1.1);
}

.notification-body {
  margin-bottom: 10px;
}

.notification-body p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.notification-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
}

/* 从右侧滑入的动画 */
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
